import {
    LOGIN_LOAD_REQUESTED,
    LOGIN_LOAD_SUCCEEDED,
    LOGIN_LOAD_FAILED,
    RENEW_ID_TOKEN,
    RENEW_ID_TOKEN_SUCCEEDED,
    RENEW_ID_TOKEN_ERROR,
    RESET_STATE,
    SIGN_IN_AS_USER
} from './constants';

interface LoginAction {
    type: string;
    payload: {
        username: string,
        password: string
    };
}

export function login(username: string, password: string): LoginAction {
    return {
        type: LOGIN_LOAD_REQUESTED,
        payload: {
            username,
            password
        }
    };
}

interface LoggedInAction {
    type: string;
    payload: string;
}

export function loggedIn(idToken: string): LoggedInAction {
    return {
        type: LOGIN_LOAD_SUCCEEDED,
        payload: idToken
    };
}

interface LoggingInErrorAction {
    type: string;
    payload: Error;
    error: boolean;
}

export function loggingInError(error: Error): LoggingInErrorAction {
    return {
        type: LOGIN_LOAD_FAILED,
        payload: {
            response: {
                data: error
            }
        },
        error: true,
        meta: {
            logentries: true
        }
    };
}

interface RenewIdTokenAction {
    type: string;
}

export function renewIdToken(): RenewIdTokenAction {
    return {
        type: RENEW_ID_TOKEN
    };
}

interface IdTokenRenewedAction {
    type: string;
    payload: string;
}

export function idTokenRenewed(idToken: string): IdTokenRenewedAction {
    return {
        type: RENEW_ID_TOKEN_SUCCEEDED,
        payload: idToken
    };
}

interface IdTokenRenewingErrorAction {
    type: string;
    payload: Error;
    error: boolean;
}

export function idTokenRenewingError(error: Error): IdTokenRenewingErrorAction {
    return {
        type: RENEW_ID_TOKEN_ERROR,
        payload: error,
        error: true,
        meta: {
            logentries: true
        }
    };
}

interface ResetStateAction {
    type: string;
    payload: Record<string, any>;
}

export function resetState(): ResetStateAction {
    return {
        type: RESET_STATE,
        payload: {}
    };
}

interface SignInAsUserAction {
    type: string;
    payload: string;
}

export function signInAsUser(hash: string): SignInAsUserAction {
    return {
        type: SIGN_IN_AS_USER,
        payload: hash
    };
}
